import { render, staticRenderFns } from "./available-courseworks-component.vue?vue&type=template&id=0f4a9b04&scoped=true"
import script from "./available-courseworks-component.vue?vue&type=script&setup=true&lang=ts"
export * from "./available-courseworks-component.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./available-courseworks-component.vue?vue&type=style&index=0&id=0f4a9b04&prod&scoped=true&lang=css"
import style1 from "./available-courseworks-component.vue?vue&type=style&index=1&id=0f4a9b04&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4a9b04",
  null
  
)

export default component.exports